import { cn } from '../../lib/utils'
import type { SourceTier } from '../../types/story'

const TIER_STYLES: Record<SourceTier, string> = {
  authoritative:
    'bg-indigo-500/10 text-indigo-700 dark:text-indigo-300 border-indigo-500/20',
  research:
    'bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/20',
  specialist:
    'bg-cyan-500/10 text-cyan-700 dark:text-cyan-300 border-cyan-500/20',
  general:
    'bg-neutral-500/10 text-neutral-700 dark:text-neutral-300 border-neutral-500/20',
}

const TIER_SHORT: Record<SourceTier, string> = {
  authoritative: 'T1',
  research: 'T2',
  specialist: 'T3',
  general: 'T4',
}

const TIER_FULL: Record<SourceTier, string> = {
  authoritative: 'Authoritative (T1)',
  research: 'Research (T2)',
  specialist: 'Specialist (T3)',
  general: 'General (T4)',
}

interface TierBadgeProps {
  tier: SourceTier
  className?: string
}

export function TierBadge({ tier, className }: TierBadgeProps) {
  const short = TIER_SHORT[tier]
  const full = TIER_FULL[tier]
  return (
    <span
      role="status"
      title={full}
      aria-label={`Source tier: ${full}`}
      className={cn(
        'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold',
        TIER_STYLES[tier],
        className,
      )}
    >
      {short}
    </span>
  )
}
